export default __webpack_public_path__ + "static/media/witcoin.85142006.png";